import React, { Component } from 'react';

/**
 * Placeholder view for while the app is loading data
 */
class BestOfferLoader extends Component {
  render() {
    return (
      <p>Loading...</p>
    );
  }
}


export default BestOfferLoader;




/** WEBPACK FOOTER **
 ** ./src/pages/TrimView/BestOfferList/BestOfferLoader/index.js
 **/